<template>
  <span @mouseover="handleShowInfo(code)" @mouseleave="handleShowInfo(null)">
    <PieChart
      v-if="series.some(Boolean)"
      :class="`width-percent-100 height-percent-100 ${chartBoxClass}`"
      :series="series"
    />
    <div
      v-if="chartItemInfoId === code"
      :class="`position-absolute z-index-1 width-200 background-surface box-shadow--modal border-radius-8 padding-8 font-size-12 color-complementary-300 ${infoBoxClass}`"
    >
      <div class="">
        <span class="color-success margin-left-8">
          <mdicon name="circle" size="12" />
        </span>
        <span class="">
          {{ $lang.activeParvandeh }}:
          {{ infoBoxData.activeParvandehCount }}</span
        >
      </div>
      <div class="">
        <span class="color-complementary-300 margin-left-8">
          <mdicon name="circle" size="12" />
        </span>
        <span class="">
          {{ $lang.archiveParvandeh }}:
          {{ infoBoxData.archiveParvandehCount }}
        </span>
      </div>
      <div class="">
        <span class="color-primary margin-left-8">
          <mdicon name="circle" size="12" />
        </span>
        <span class="">
          {{ $lang.successPreRegister }}:
          {{ infoBoxData.successPreRegisterCount }}</span
        >
      </div>
    </div>
  </span>
</template>

<script>
import { Pie as PieChart } from "@/components/charts";
import { toRefs } from "vue";

export default {
  components: { PieChart },
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    code: {
      type: [String, Number],
      default: null,
    },
    chartItemInfoId: {
      type: [String, Number],
      default: null,
    },
    chartBoxClass: {
      type: String,
      default: "flex-center",
    },
    infoBoxClass: {
      type: String,
      default: "right--80 top-65",
    },
    infoBoxData: {
      type: Object,
      default: null,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { series, code, chartItemInfoId, infoBoxData } = toRefs(props);

    const handleShowInfo = (code) => emit("handleShowInfo", code);

    // return data to be used in template
    return { series, code, chartItemInfoId, infoBoxData, handleShowInfo };
  },
};
</script>
